export const removeChannelItemPrefix = (audioItem) =>
  Object.keys(audioItem).reduce((res, dataItem) => (
    {...res, [dataItem.replace("channels_", "")]: audioItem[dataItem]}
  ), {});
